import {uniq} from 'lodash-es';
import {
    GetEventsByCityRequest,
    EventByCityItem,
    GetEventsByCityResponse,
    RawGetEventsByCityRequest,
} from 'api/events/events.types';
import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {convertKeysToSnakeCase} from 'utils/format-strings';

const formatGetEventsByCitiesRequest = (
    requestData: GetEventsByCityRequest
): RawGetEventsByCityRequest => {
    const formattedRequest = convertKeysToSnakeCase(requestData);

    return formattedRequest;
};

export type GetEventsByCitiesParams = {
    cityIds: number[];
    page: number;
    pageSize: number;
    fromDate: string;
    toDate: string;
    eventTypeIds?: number[];
    venueIds?: number[];
    searchText?: string;
};

const getEventsByCities = async (
    requestData: GetEventsByCitiesParams,
    config = {}
): Promise<GetEventsByCityResponse> => {
    const formattedRequest = formatGetEventsByCitiesRequest({
        city: uniq(requestData.cityIds),
        page: requestData.page,
        pageSize: requestData.pageSize,
        camelize: true,
        include: 'destination',
        fromDate: requestData.fromDate,
        toDate: requestData.toDate,
        ...(requestData.eventTypeIds &&
            requestData.eventTypeIds.length > 0 && {
                type: requestData.eventTypeIds,
            }),
        ...(requestData.venueIds &&
            requestData.venueIds.length > 0 && {
                venue: requestData.venueIds,
            }),
        ...(requestData.searchText && {searchText: requestData.searchText}),
    });

    try {
        const response = await spotheroGet<EventByCityItem[]>(
            `events/by-cities/`,
            formattedRequest,
            {
                paramsSerializer: {
                    indexes: null,
                },
                ...config,
            }
        );

        return response.data;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventsByCities;
